import { useLocalize } from 'localize-react';
import React  from 'react';

import { PopConfirm } from '../../../../../../components/PopConfirm/PopConfirm';

export const CancelJourney: React.FC<any> = ({
  bodyText,
  onConfirm,
  loading,
  showConfirm,
}) => {
  const { translate } = useLocalize();

  return (
    <div className="cancel-trip">
      <PopConfirm
        title={translate('cancelTrip')}
        bodyText={bodyText}
        onConfirm={() => onConfirm()}
        isLoading={loading}
        showConfirm={showConfirm}
      >
        <a href="#" className="cancel-trip-link">{translate('cancelTrip')}</a>
      </PopConfirm>
    </div>
  );
};
